<template>
  <div class="tcdc-divider"></div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.tcdc-divider {
  border-bottom: 2px solid $tcdcGreen;
}
</style>
